import { VERSION_CONTENT_CONTAINER_ID } from '../../../shared/constants';
import { getAccessibleIconBtn, linkButtonClass } from './makeContent';

interface IAddButtonsToImportedLinksProps {
  iconClassName: string;
  description: string;
}

/**
 * Adds icon buttons to the anchor tags of imported links.
 *
 * @param {string} iconClassName - The class name of the icon to be displayed on the button.
 * @param {string} description - The description for the icon button.
 */
const addButtonsToImportedLinks = ({
  iconClassName,
  description,
}: IAddButtonsToImportedLinksProps) => {
  const contentContainer = document.getElementById(
    VERSION_CONTENT_CONTAINER_ID,
  );
  const importedRefs = Array.from(
    contentContainer?.querySelectorAll(
      'a[refnorm], a[refpara], a[refabs], a[refsatz], a[refnr]',
    ) || [],
  );

  importedRefs.forEach((ref) => {
    if (ref.nextElementSibling?.nodeName === 'BUTTON') {
      return;
    }

    const id = ref.id || '';
    const button = getAccessibleIconBtn({
      id,
      iconClassName,
      description,
    });
    ref.insertAdjacentElement('afterend', button);
  });
};

/**
 * Removes icon buttons from the anchor tags of imported links.
 */
const removeButtonsFromImportedLinks = () => {
  const contentContainer = document.getElementById(
    VERSION_CONTENT_CONTAINER_ID,
  );
  const refButtons = Array.from(
    contentContainer?.querySelectorAll(`.${linkButtonClass}`) || [],
  );

  refButtons.forEach((btn) => {
    btn?.remove();
  });
};

export { addButtonsToImportedLinks, removeButtonsFromImportedLinks };
